document.addEventListener('DOMContentLoaded', function () {
  const inputs = document.querySelectorAll('.variant_input');
  const planSelect = document.querySelector('#select_delivery_time');

  inputs.forEach(input => {
    input.addEventListener('change', function () {

      const price = this.dataset.price || '';
      const subprice = this.dataset.subprice || '';
      const compareprice = this.dataset.compareprice || '';
      const each = this.dataset.each || '';
      const id = this.value || '';

      const elPrice = document.querySelector('.onetime_price');
      const elSubPrice = document.querySelector('.subs_price');
      const elCompare = document.querySelector('.previous-subscription-fee');
      const elEachPrice = document.querySelector('.monthly_pay');
      const elId = document.querySelector('.product-variant-id');

      // update UI
      if (elPrice) {
        elPrice.textContent = price;
        elSubPrice.textContent = subprice;
        elCompare.textContent = compareprice;
        elEachPrice.textContent = each;
        elId.value = id;
      }

      // ==============================
      // AUTO SELECT SELLING PLAN
      // ==============================
      if (planSelect) {
        const inputsArray = Array.from(inputs);
        const variantIndex = inputsArray.indexOf(this);

        const options = planSelect.querySelectorAll('option');

        if (options[variantIndex]) {
          planSelect.value = options[variantIndex].value;

          // optional: trigger change event if needed by Shopify
          planSelect.dispatchEvent(new Event('change'));
        }
      }

    });
  });
});

document.addEventListener('DOMContentLoaded', function () {

  const radios = document.querySelectorAll('input[name="plan"]');
  const select = document.querySelector('#select_delivery_time');
  const hidden = document.querySelector('#selling_plan');

  function updateSellingPlan() {
    const plan = document.querySelector('input[name="plan"]:checked').value;

    if (plan === "1") {
      // subscription selected → get dropdown value
      hidden.value = select.value;

      console.log('subscription selling_plan:', select.value);

    } else {
      // one-time purchase → clear selling plan
      hidden.value = "";

      console.log('one-time purchase');
    }
  }

  // run on load
  updateSellingPlan();

  // radio change
  radios.forEach(radio => {
    radio.addEventListener('change', updateSellingPlan);
  });

  // dropdown change (important!)
  select.addEventListener('change', updateSellingPlan);

});